const RessourceReducer =  (state = [], action) => {
      return state
}

export default RessourceReducer;
